import type { SynthesisRequest } from './model.js';

const encoder = new TextEncoder();

export async function sha256Hex(value: string | Uint8Array): Promise<string> {
  const bytes = typeof value === 'string' ? encoder.encode(value) : value;
  const input = new Uint8Array(bytes.byteLength);
  input.set(bytes);
  const digest = await globalThis.crypto.subtle.digest('SHA-256', input.buffer);
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}

/**
 * Stable cache identity for every setting that can change generated speech.
 * Consent and provider credentials are deliberately excluded.
 */
export async function synthesisCacheKey(request: SynthesisRequest): Promise<string> {
  return sha256Hex(
    JSON.stringify({
      text: request.text,
      voiceId: request.voiceId,
      modelId: request.modelId,
      locale: request.locale,
      rate: request.rate,
      pitch: request.pitch,
      volume: request.volume,
      pauseAfterSentenceMs: request.pauseAfterSentenceMs,
      lexiconVersion: request.lexiconVersion,
      outputFormat: request.outputFormat ?? 'mp3_44100_128',
      pronunciationDictionaryLocators: [...(request.pronunciationDictionaryLocators ?? [])]
        .map((item) => ({ id: item.id, versionId: item.versionId }))
        .sort((a, b) => `${a.id}:${a.versionId}`.localeCompare(`${b.id}:${b.versionId}`)),
    }),
  );
}
